import React from 'react'
import { useLocation } from 'react-router-dom'

import { RoutePath } from '@/routes'

import { ConverSation, HowItWorks } from '../common/Lottie'

const Float: React.FC = () => {
  const { pathname } = useLocation()
  if (pathname === RoutePath.HOME)
    return <ConverSation className="fixed bottom-20 right-8 z-[3]" />

  if (
    [
      RoutePath.AIRDROP,
      RoutePath.MINING_PLATFORM,
      RoutePath.MINING_INFLUENCE,
      RoutePath.DAO
    ].includes(pathname as RoutePath)
  )
    return (
      <HowItWorks
        className="fixed bottom-20 right-8 z-[3]"
        pathname={pathname}
      />
    )

  return null
}

export default Float
